/**
 * Custom Transparent Header — At-Top Class Manager
 * Adds/removes 'header--at-top' class based on scroll position.
 * Measures total header-group height (all sibling sections) for negative margin.
 * Works alongside Dawn's native StickyHeader class.
 */

(function () {
  const headerWrapper = document.querySelector('.header-wrapper[data-is-transparent="true"]');
  if (!headerWrapper) return;

  function setHeaderGroupHeight() {
    // --header-group-height must equal the VISIBLE header bar height — i.e. the
    // .header-wrapper ("le header réel"), nothing else. Summing the header-group sections
    // overshoots: it picks up the off-canvas cart drawer and, critically, the announcement
    // bar (which is opacity:0 but still occupies ~33px at the top in the transparent state).
    // Measuring .header-wrapper directly gives the exact bar height with no overshoot.
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;
    const h = headerWrapper.offsetHeight;
    // Sanity clamp: a header bar is never legitimately taller than ~400px.
    if (h > 0 && h < 400) {
      document.documentElement.style.setProperty('--header-group-height', Math.round(h) + 'px');
    }
  }

  // Measure now, after full load (logo/fonts settled), and on resize.
  setHeaderGroupHeight();
  window.addEventListener('load', setHeaderGroupHeight, { passive: true });
  window.addEventListener('resize', setHeaderGroupHeight, { passive: true });

  // Set initial state
  if (window.scrollY <= 2) {
    headerWrapper.classList.add('header--at-top');
  } else {
    headerWrapper.classList.remove('header--at-top');
  }

  let ticking = false;

  function updateHeaderState() {
    if (window.scrollY <= 2) {
      headerWrapper.classList.add('header--at-top');
    } else {
      headerWrapper.classList.remove('header--at-top');
    }
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        requestAnimationFrame(updateHeaderState);
        ticking = true;
      }
    },
    { passive: true }
  );
})();
